<ng-container *transloco="let t; prefix: 'experience'">
  <section>
    <div class="slideshow">
      <swiper-container
        (breakpoint)="onSwiperResize($event)"
        (slideChange)="onSlideChange($event)"
        [config]="config"
        data-cy="what-we-love-slider"
        essFrontSwiper
        init="false"
      >
        @for (slide of whatWeLoveGallery; track slide) {
          <swiper-slide essFrontSwiperSlide>
            <div class="slide-wrapper">
              <img
                class="slide-image"
                alt="{{ t('experienceImage') }}"
                [src]="slide.image"
                data-cy="what-we-love-slider-img"
              />
              <div class="slide-overlay">
                <div class="slide-text">
                  <h3 class="heading-s"
                    ><strong data-cy="what-we-love-slider-title">{{ t('whatWeLove') }}</strong></h3
                  >
                  <div class="slide-caption" data-cy="what-we-love-slider-caption">{{ slide.content_title }}</div>
                </div>
              </div>
            </div>
          </swiper-slide>
        }
      </swiper-container>
      <div class="slideshow-pagination-mobile"></div>
      <div class="slideshow-pagination">
        <div class="pagination-container">
          <div
            [ngStyle]="{width: paginationPointerWidth + '%', left: paginationPointerLeft + '%'}"
            class="pagination-pointer"
          ></div>
        </div>
      </div>
      <div class="slideshow-navigation">
        <button
          type="button"
          [attr.aria-label]="t('previousSlide')"
          class="nav-prev button-content"
          data-cy="what-we-love-slider-prev"
        >
          <i class="button-prev-arrow" [innerHTML]="prevArrowIcon"></i>
        </button>
        <button
          type="button"
          [attr.aria-label]="t('nextSlide')"
          class="nav-next button-content"
          data-cy="what-we-love-slider-next"
        >
          <i class="button-next-arrow" [innerHTML]="nextArrowIcon"></i>
        </button>
      </div>
    </div>
  </section>
</ng-container>
